import React, { useMemo } from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../styles";
import { buildMonitoringExportRows } from "../../helpers/complianceExport";
import { ComplianceTable, SectionTitle } from "../../shared";

const ComplianceMonitoringSection = ({ t, supplierData = {}, meta }) => {
    const monitoringRows = useMemo(
        () => buildMonitoringExportRows(supplierData?.complianceMonitoring, { t }),
        [supplierData?.complianceMonitoring, t]
    );

    return (
        <View style={styles.wordSectionContent}>
            <ComplianceTable
                leading={(
                    <SectionTitle
                        title={meta?.title || "Compliance Monitoring"}
                        number={meta?.number}
                        anchorId={meta?.anchorId}
                    />
                )}
                rows={monitoringRows}
            />
        </View>
    );
};

export default withNamespaces()(ComplianceMonitoringSection);
